import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  useMediaQuery,
  Typography,
  Button,
} from "@mui/material";
import { connect } from "react-redux";

const ZipcodeErrorMsg = (props) => {
  const {
    initialize = null,
    zipErrorMessage,
    zipDataIsProgress,
    zipDataStatus,
  } = props;
  const matchesMinWidth = useMediaQuery("(max-width:600px)");
  let storedZipData = JSON.parse(localStorage.getItem("storedZipData"));

  const [showZipcodeError, setShowZipcodeError] = useState(false);
  useEffect(() => {
    if (zipErrorMessage && !zipDataStatus && !zipDataIsProgress) {
      setShowZipcodeError(true);
    }
  }, [zipErrorMessage, zipDataStatus]);

  useEffect(() => {
    if (zipDataIsProgress) {
      setShowZipcodeError(false);
    }
  }, [zipDataIsProgress]);

  return (
    <>
      {showZipcodeError ? (
        <Dialog
          open={showZipcodeError}
          sx={{ zIndex: 9999 }}
          id="zipcodeerror"
          className="info-dialog"
        >
          <DialogContent
            sx={{
              paddingLeft: matchesMinWidth ? "24px" : "40px",
              paddingRight: matchesMinWidth ? "24px" : "40px",
            }}
          >
            <Box mt={2}>
              <Typography variant="text4">{zipErrorMessage}</Typography>
            </Box>
            <Box mt={3} mb={1}>
              <Button
                sx={{ width: 100 }}
                variant="filled"
                onClick={() => {
                  document.getElementById("appcontent").scroll(0, 0);
                  setShowZipcodeError(false);
                  if (initialize) {
                    initialize({
                      zipCode: storedZipData?.zipCode || "",
                    });
                  }
                }}
              >
                OK
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    zipDataStatus: state.zipData.zipDataStatus,
    zipData: state.zipData.data,
    zipErrorMessage: state.zipData.message,
    zipDataIsProgress: state.zipData.isProgress,
  };
};

export default connect(mapStateToProps)(ZipcodeErrorMsg);
